// extracted by mini-css-extract-plugin
export default {"Strikethrough":"Sm2WFDbI"};